import { graphql } from "react-relay";
import { AvatarPerson } from "@components/avatar";

export const teammateHealthAvatarFragments = {
  org: graphql`
    fragment TeammateHealthAvatar_org on Org {
      id
      experiments
    }
  `,
  calendarFocusTimeScore: graphql`
    fragment TeammateHealthAvatar_calendarFocusTimeScore on CalendarFocusTimeScore {
      calendarId
      busyMinutes
      focusMinutes
      totalMinutes
      crawledStatus
    }
  `,
  person: graphql`
    fragment TeammateHealthAvatar_person on Person {
      __typename
      id
      emails
      primaryEmail
      isYou
      userId
      isUser
      profile {
        givenName
        familyName
        externalImageUrl
      }
    }
  `,
};
